var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinHardMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "8 1 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 22C46 31.9411 28 52 28 52C28 52 10 31.9411 10 22C10 12.0589 18.0589 4 28 4C37.9411 4 46 12.0589 46 22Z",
    fill: "#172057"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 22,
    r: 12,
    fill: "#58bbef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinHardMulti);
export default __webpack_public_path__ + "static/media/pin-hard-multi.4b8b4d7b42fbb36812ec5abca6860a0a.svg";
export { ForwardRef as ReactComponent };